import React, { useState } from "react";
import { View } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { useTheme } from "@rneui/themed";
import { Image } from "../../../components/shared";
import { getGradientWidth } from "../utils";
const GRADIENT_HEIGHT = 400;
const AlignedImage = ({ width, height, uri = "", bottomGradient = false, blackGradient, }) => {
    const [imageAspect, setImageAspect] = useState(width / height);
    const { theme } = useTheme();
    const gradientWidth = getGradientWidth(width);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                position: "absolute",
                overflow: "hidden",
                width,
                height,
            } },
            React.createElement(View, { style: {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: Math.max(width, height * imageAspect),
                    height: Math.max(height, width / imageAspect),
                } },
                React.createElement(Image, { uri: uri, widthConstraint: Math.max(width, height * imageAspect), resizeMode: "contain", onSize: (dimensions) => {
                        const newAspect = dimensions.width / dimensions.height;
                        if (Math.abs(imageAspect - newAspect) >= 0.01) {
                            setImageAspect(dimensions.width / dimensions.height);
                        }
                    } })),
            blackGradient ? (React.createElement(LinearGradient, { colors: ["#00000000", "#000000"], start: blackGradient.start, end: blackGradient.end, style: {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: gradientWidth,
                    height: "100%",
                } })) : null,
            bottomGradient ? (React.createElement(LinearGradient, { colors: ["transparent", theme.colors.backgroundPrimary], start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, style: {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: GRADIENT_HEIGHT,
                } })) : null)));
};
export default AlignedImage;
//# sourceMappingURL=AlignedImage.js.map